










import { Component, Prop, Vue } from 'vue-property-decorator';
import { deviceApi } from '../device.api';

@Component
export default class DeviceSyncConfigBtn extends Vue {
  @Prop()
  public device: any;

  public syncingDevice = false;

  public get isBtnVisible(): boolean {
    return !this.device.subscriptionConfigSyncedWithDevice
      && this.device.uuid
      &&  !this.device.deletedAt;
  }

  public async setSubscriptionConfigBackToBase(): Promise<void> {
    try {
      await deviceApi.setSubscriptionConfigBackToBase(this.device.id);
      this.$buefy.snackbar.open({
        message: 'Programmation mise à jour',
        type: 'is-success',
      });
      this.$emit('reset');
    } catch (_) {
      this.$buefy.snackbar.open({
        message: 'Erreur lors du retour à la programmation de base',
        type: 'is-danger',
      });
    }
  }


  public async syncDeviceConfig(): Promise<void> {
    this.syncingDevice = true;

    try {
      await deviceApi.syncConfiguration(this.device.id);
      this.device.subscriptionConfigSyncedWithDevice = true;

      this.$buefy.snackbar.open({
        message: 'Configuration synchronisée',
        type: 'is-success',
      });
      this.$emit('sync');
    } catch (_) {
      this.$buefy.snackbar.open({
        message: 'Erreur de synchronisation',
        type: 'is-danger',
      });
    }

    this.syncingDevice = false;
  }
}
